import axios from "axios";

export const getCustomerInfo = (accessToken, userId) => {
  const apiKey = "4d50cc22-a0ce-4afc-af51-44bf44cdbc4c";

  const config = {
    headers: { Authorization: `${accessToken}`, "x-client-id": apiKey },
  };
  return axios
    .get(`https://api.ingka.ikea.com/api/profile/icm/us/${userId}`, config)
    .then((response) => {
      const icmCustomerData = response.data.customers[0];

      const customerInfo = {
        firstName: icmCustomerData.firstName,
      };

      return customerInfo;
    })
    .catch((error) => {
      console.log(error);
      return { error: { details: error } };
    });
};
